var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:[
		_vm.$s.TextButton,
		_vm.$s[("size_" + _vm.resolvedSize)],
		( _obj = {}, _obj[_vm.$s.loading] = _vm.loading, _obj )
	],style:(_vm.style),attrs:{"type":_vm.type,"disabled":_vm.isDisabled,"aria-label":_vm.ariaLabel}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('m-loading',{class:_vm.$s.Loading}):_vm._e(),_vm._v(" "),_c('span',{class:[
			_vm.$s.MainText,
			( _obj$1 = {}, _obj$1[_vm.$s.TruncateText] = _vm.truncateText, _obj$1 )]},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }